import { render, staticRenderFns } from "./tdata.vue?vue&type=template&id=0714b162&scoped=true&"
import script from "./tdata.vue?vue&type=script&lang=js&"
export * from "./tdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0714b162",
  null
  
)

export default component.exports